// O número publicado (2.0.x, 2.1.0, 3.0.0) pede login de novo.
// O mesmo número com outro build só recarrega a página.

export function decideRelease(running, remote, context) {
  const storedVersion = (context && context.storedVersion) || ''
  const hasSession = !!(context && context.hasSession)
  const alreadyApplied = (context && context.alreadyApplied) || ''
  const runningVersion = (running && running.version) || ''
  const runningBuild = (running && running.build) || ''
  const remoteVersion = remote && remote.version
  const remoteBuild = (remote && remote.build) || ''

  if (remoteVersion && remoteVersion !== runningVersion) {
    if (alreadyApplied && alreadyApplied === remoteBuild) return { action: 'none' }
    return {
      action: hasSession ? 'logout' : 'reload',
      version: remoteVersion,
      build: remoteBuild,
    }
  }

  if (remoteBuild && runningBuild && remoteBuild !== runningBuild) {
    if (alreadyApplied && alreadyApplied === remoteBuild) return { action: 'none' }
    return { action: 'reload', version: runningVersion, build: remoteBuild }
  }

  if (storedVersion && storedVersion !== runningVersion) {
    return {
      action: hasSession ? 'logout' : 'reload',
      version: runningVersion,
      build: runningBuild,
    }
  }

  if (!storedVersion && runningVersion) {
    return { action: 'remember', version: runningVersion, build: runningBuild }
  }

  return { action: 'none' }
}
